import { credibilityData } from "../data/mock";
import { Award, Users, Briefcase, UserCheck, Eye, MapPin } from "lucide-react";

const iconMap = {
  0: Award,
  1: Users,
  2: Briefcase,
  3: UserCheck,
  4: Eye,
  5: MapPin,
};

export const CredibilitySection = () => {
  return (
    <section className="relative py-20" style={{ background: "#252422" }}>
      <div className="max-w-[87.5rem] mx-auto px-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {credibilityData.stats.map((stat, i) => {
            const Icon = iconMap[i];
            return (
              <div
                key={i}
                className="flex flex-col items-center text-center group"
              >
                <div className="mb-3 p-2.5 border border-[#3f4816]/30 rounded-md transition-colors duration-300 group-hover:border-[#3f4816]/60">
                  <Icon size={18} className="text-[#d9fb06]" />
                </div>
                <span
                  className="text-[#dfddd6] font-black text-2xl mb-1"
                  style={{
                    fontFamily: "'Inter', Arial, sans-serif",
                    letterSpacing: "-0.02em",
                  }}
                >
                  {stat.value}
                </span>
                <span
                  className="text-[#888680] font-medium text-xs uppercase tracking-wider mb-0.5"
                  style={{ fontFamily: "'Inter', Arial, sans-serif" }}
                >
                  {stat.label}
                </span>
                <span
                  className="text-[#888680]/60 text-[10px] leading-tight"
                  style={{ fontFamily: "'Inter', Arial, sans-serif" }}
                >
                  {stat.sublabel}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
